import React, { useMemo, useState } from 'react'
import ArrowRightIcon from '../../../assets/Icons/ArrowRightIcon';

const MenuList = (props) => {
    const { ell = {}, setSeatInfoDrop = () => { }, bkgDeatails = {}, setTooltipOpen = () => { }, userDetails = {}, handleSeatModDetails = () => { } } = props
    const [hoveredItem, setHoveredItem] = useState(null);
    //6
    let dropDownList = useMemo(() => {
        let arr = []
        let agentRole = bkgDeatails.roleRight || {}
        if (ell.ForAgentID === userDetails?.AgentID) {
            if (ell.BookingID != null) {
                arr.push({
                    name: 'Copy PNR', id: 6,
                    subMenu: ell.seatInfo
                })
            }
            if (ell.bookingTypeArr.includes("AP") && (agentRole.AllowPhoneModify === 1)) {
                arr.push({
                    name: 'Phone To Confirm', id: 1,
                    subMenu: ell.seatInfo?.length > 0 ? ell.seatInfo?.filter((obj) => {
                        if (obj.BookingType === 'AP') {
                            return obj
                        }
                    }) : []
                })
            }
            if (ell.BookingID != null && (ell.BookingType === "AC" ? agentRole.AllowConfirmCancel === 1 : agentRole.AllowPhoneCancel === 1)) {
                arr.push({
                    name: 'Cancel', id: 2, subMenu: ell.seatInfo.filter((obj) => {
                        return (obj.BookingType === "AC" ? agentRole.AllowConfirmCancel === 1 : agentRole.AllowPhoneCancel === 1)
                    })
                })
            }
            if (ell.BookingType !== null && ell.Seatcount > 1 && (ell.BookingType === "AC" ? agentRole.AllowConfirmCancel === 1 : agentRole.AllowPhoneCancel === 1)) {
                arr.push({
                    name: 'Partial cancel', id: 3, subMenu: ell.seatInfo.filter((obj) => {
                        return obj.Seatcount > 1 && (obj.BookingType === "AC" ? agentRole.AllowConfirmCancel === 1 : agentRole.AllowPhoneCancel === 1)
                    })
                })
            }
            if ((ell.bookingTypeArr.includes("AP") && agentRole.AllowPhoneModify === 1) || (ell.bookingTypeArr.includes("AC") && agentRole.AllowConfirmModify === 1)) {
                arr.push({
                    name: 'Modify', id: 7, subMenu: ell.seatInfo.filter((obj) => {
                        return (ell.BookingType === "AP" && agentRole.AllowPhoneModify === 1) || (ell.BookingType === "AC" && agentRole.AllowConfirmModify === 1)
                    })
                })
            }
            if (ell.BookingID != null && ell.BookingType === "AC") {
                arr.push({
                    name: 'Print', id: 4, subMenu: ell.seatInfo.filter((obj) => {
                        return ell.BookingType === "AC"
                    })
                })
            }
            if (ell.BookingID != null) {
                arr.push({ name: 'WhatsApp Me', id: 5, subMenu: [] })
            }


        }
        return arr
    }, [ell, userDetails?.AgentID, bkgDeatails.roleRight])

    return (
        <>
            <div className='seatInfoDropDown'
                onMouseLeave={() => {
                    setSeatInfoDrop(false);
                    setTooltipOpen(null)

                }}
            >
                {dropDownList?.length > 0 ? dropDownList.map((obj) => (
                    <>
                        <div
                            key={obj.id}
                            className={`list ${hoveredItem === obj.id ? 'active' : ''}`}
                            onMouseEnter={() => {
                                setHoveredItem(obj.id)
                                setTooltipOpen(null)
                            }}
                            onMouseLeave={() => {
                                setHoveredItem(null)
                                setTooltipOpen(null)
                            }}
                            onClick={() => {
                                if (ell.seatInfo.length === 1) {
                                    handleSeatModDetails(true, obj.id, ell)
                                    setSeatInfoDrop(false);
                                    setTooltipOpen(null)
                                }
                            }}
                        >
                            <span>
                                {obj.name}
                            </span>
                            {(ell.seatInfo.length > 1 && obj.subMenu?.length > 0) && <ArrowRightIcon />}
                            {(ell.seatInfo.length > 1 && obj.subMenu?.length > 0) && hoveredItem === obj.id && (
                                <div className="submenu">
                                    {obj.subMenu.map((sub, idx) => (
                                        <div key={idx}
                                            className="submenu-item"
                                            onClick={() => {
                                                handleSeatModDetails(true, obj.id, sub)
                                                setHoveredItem(null)
                                                setSeatInfoDrop(false);
                                                setTooltipOpen(null)
                                            }}
                                        >{`${sub.PaxName}(${sub.RouteName})PNR:${sub.BookingID}`}</div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </>
                ))
                    :
                    <div className='list'>No Found</div>
                }
            </div>
        </>
    )
}

export default MenuList